import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import {
  sentryClientDsn,
  sentryConfig,
} from 'src/common/constants/analytics/sentry';
import shouldLogToSentry from '../../common/utils/shouldLogToSentry';

if (shouldLogToSentry()) {
  const options = {
    ...sentryConfig,
    whitelistUrls: [/tunein\.com/],
    ignoreErrors: [
      "Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
    ],
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  };

  Sentry.init({
    dsn: sentryClientDsn,
    ...options,
  });
}
